import React, { useEffect, useRef } from 'react';
import EmojiPicker from "../Common/EmojiPicker";

const MessageDisplay = ({
  messages,
  communicationUserId,
  handleDropDown,
  role,
  messageDeleted,
  setEditingMessageId,
  handleDeleteMessage,
  editingMessageId,
  validationMessageRef,
  newMessageEdit,
  setNewMessageEdit,
  handleSendMessage,
  setIsEditEmojiPicker,
  isEditEmojiPicker,
  handleEmojiClickEdit,
}) => {
  const emojiPickerEditRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        emojiPickerEditRef.current &&
        !emojiPickerEditRef.current.contains(event.target)
      ) {
        setIsEditEmojiPicker(false);
      }
    };

    if (isEditEmojiPicker) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isEditEmojiPicker]);

  return (
    <div className="chat-text" id="chatText">
      {messages?.length > 0 &&
        messages
          .slice()
          .map(
            (message, index) =>
              message.type === "text" &&
              message.content.message !== "" && (
                <React.Fragment key={index}>
                  <div className="chat-avatar-wrap">
                    {message.content.message !==
                      "Chat is Disabled by Host" &&
                      message.content.message !==
                      "Chat is Enabled by Host" &&
                      !message.isDeleted && (
                        <div className="avatar-size">
                          <div className="avatar chatScreenAvtar" style={{
                            backgroundImage: `url(${message?.photo})`,
                          }}>
                            <div className="initialspusername">
                              {message?.photo?.length > 0 ? "" : message?.initials}
                            </div>
                          </div>
                        </div>
                      )}
                    <div className="chat-info-wrap">
                      <div className="chat-info">
                        {!(message.isDisableChat !== undefined) &&
                          !message.isDeleted && (
                            <span>
                              {message?.communicationUserId ===
                                communicationUserId.communicationUserId
                                ? "Me"
                                : message.senderDisplayName}{" "}
                            </span>
                          )}{" "}
                        {!(message.isDisableChat !== undefined) &&
                          !message.isDeleted && (
                            <span className="message-timestamp">
                              {new Date(
                                message.createdOn
                              ).toLocaleTimeString([], {
                                hour: "2-digit",
                                minute: "2-digit",
                                hour12: true,
                              })}
                              {message.editedOn &&
                                !message.isDeleted && (
                                  <span className="edited-label">
                                    {" "}
                                    Edited{" "}
                                  </span>
                                )}
                            </span>
                          )}
                      </div>
                      {!message.isDeleted && (
                        <div
                          className={`${message.isDisableChat !== undefined
                            ? "chat-enabled scrollfirst"
                            : "chat-bubble"
                            }  ${message?.communicationUserId ===
                            communicationUserId.communicationUserId &&
                            "by-me"
                            }`}
                          id={message.id}
                          style={{ display: editingMessageId === message.id && "none" }}
                          onClick={(e) => handleDropDown(message.id)}
                        >
                          {message.isDisableChat !== undefined &&
                            role === "Presenter"
                            ? message.isDisableChat
                              ? "Chat is disabled for all participants"
                              : "Chat is enabled for all participants"
                            : message.content.message}
                          {message.isDisableChat !== undefined && (
                            <span>
                              {new Date(
                                message.createdOn
                              ).toLocaleTimeString([], {
                                hour: "2-digit",
                                minute: "2-digit",
                                hour12: true,
                              })}
                            </span>
                          )}
                        </div>
                      )}
                      {message.isDeleted &&
                        message.communicationUserId ===
                        communicationUserId.communicationUserId &&
                        messageDeleted(message)}
                      {message?.communicationUserId ===
                        communicationUserId.communicationUserId && (
                          <div className="dropdown slider-action-bar-dot-menu hover-ThreeDorMenu">
                            <button
                              className="btn dropdown-toggle"
                              type="button"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                            >
                              <i
                                className="fa fa-ellipsis-h"
                                aria-hidden="true"
                              ></i>
                            </button>
                            <ul className="dropdown-menu">
                              <li>
                                <a href
                                  className="edit-button dropdown-item"
                                  onClick={() => {
                                    setEditingMessageId(message.id);
                                    setNewMessageEdit(
                                      message.content.message
                                    );
                                  }}
                                >
                                  Edit
                                </a>
                              </li>
                              <li>
                                <a href
                                  className="delete-button dropdown-item"
                                  onClick={() =>
                                    handleDeleteMessage(message.id)
                                  }
                                >
                                  Delete
                                </a>
                              </li>
                            </ul>
                          </div>
                        )}
                      {/* Chat edit Screen  */}
                      {editingMessageId === message.id && (
                        <div>
                          <div className="editChatParent">
                            <div ref={validationMessageRef}
                              id="divChatMessageBlankValidation"
                              className="divChatMessageBlankValidation"
                              style={{ display: "none" }}>
                              Please type a message to continue.
                            </div>
                            <div className="chat-icon-background chat-box edit-text-box">
                              <textarea
                                className="chat-box edit-text-box"
                                maxLength="500"
                                rows="3"
                                value={newMessageEdit}
                                onChange={(e) =>
                                  setNewMessageEdit(e.target.value)
                                }
                              ></textarea>
                              <textarea
                                className="chat-box"
                                rows="3"
                                style={{ display: "none" }}
                                placeholder="Type a message"
                                data-emoji-input="unicode"
                              ></textarea>
                              <i
                                className="emoji-picker-icon emoji-picker fa fa-smile-o"
                                onClick={() =>
                                  setIsEditEmojiPicker(!isEditEmojiPicker)
                                }
                              ></i>
                            </div>

                            <div className="editDeleteChatLink">
                              <a
                                href="javascript:void(0);"
                                className="cancelEditMessage"
                                onClick={() => setEditingMessageId(null)}
                                title="Cancel message"
                              >
                                <i className="rightChatEditIcon fas fa-close"></i>
                              </a>
                              <a
                                href="javascript:void(0);"
                                onClick={handleSendMessage}
                                title="Send message"
                              >
                                <i className="rightChatEditIcon fas fa-check"></i>
                              </a>
                            </div>
                          </div>
                          {/* Append emoji picker if isEditEmojiPicker is true */}
                          <div id="editEmojiPickerSection">
                            {isEditEmojiPicker && (
                              <div
                                className={"edit-emoji-picker"}
                                ref={emojiPickerEditRef}
                              >
                                <EmojiPicker
                                  handleEmojiClick={handleEmojiClickEdit}
                                  closeEmojiPicker={() => setIsEditEmojiPicker(false)}
                                />
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                      {message.sender?.communicationUserId ===
                        communicationUserId && (
                          <div className="message-actions"></div>
                        )}
                    </div>
                  </div>
                </React.Fragment>
              )
          )}
    </div>
  )
}

export default MessageDisplay;